import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject, OnInit, signal } from '@angular/core';
import { TokenService } from '@app/core';
import { notNull } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, of } from 'rxjs';

@Component({
  selector: 'app-modal-digital-books',
  templateUrl: './modal-digital-books.component.html',
  standalone: false,
})
export class ModalDigitalBooksComponent implements OnInit {
  public readonly dialogRef = inject<DialogRef<string>>(DialogRef);
  public data = inject(DIALOG_DATA);
  private readonly store = inject(Store);
  private readonly tokenService = inject(TokenService);
  public isStudent = false;
  public isExternal = false;
  public page = 1;
  public activeUser$: Observable<any>;
  public url = signal(null);

  public get isOnlyStudent(): boolean {
    return this.data.anexos.every((anexo) => anexo.aluno === 1);
  }

  public get hasBookTeacher(): boolean {
    return this.data.anexos.some((anexo) => anexo.aluno === 0);
  }

  public get hasBookStudent(): boolean {
    return this.data.anexos.some((anexo) => anexo.aluno === 1);
  }

  public get hasBookExterno(): boolean {
    return this.data.anexos.every((anexo) => anexo.externo === 1);
  }

  public ngOnInit(): void {
    this.data = { ...this.data, formato_apresentacao: 1 };
    this.activeUser$ = this.store.select(AppSelectors.ActiveUser).pipe(notNull());

    combineLatest([this.activeUser$, this.generateTemporaryToken()]).subscribe(([user, { token }]) => {
      const isStudent = !!user?.aluno_id || this.isOnlyStudent;
      this.isStudent = isStudent;
      this.isExternal = !!user?.escola_externa;
      this.url.set(this.setUrl(token, isStudent));
    });
  }

  public setPage(page: number): void {
    this.page = page;
    this.generateTemporaryToken().subscribe(({ token }) => this.url.set(this.setUrl(token, this.isStudent)));
  }

  public setBook(isStudent = false): void {
    if (isStudent !== this.isStudent) {
      this.isStudent = isStudent;
      this.generateTemporaryToken().subscribe(({ token }) => this.url.set(this.setUrl(token, isStudent)));
    }
  }

  public onOpenBookBlank(): void {
    this.generateTemporaryToken().subscribe(({ token }) => {
      window.open(this.setUrl(token, this.isStudent), '_blank');
    });
  }

  private generateTemporaryToken(): Observable<any> {
    return this.tokenService.generateTemporaryToken();
  }

  private setUrl(token: string, isStudent?: boolean): string {
    return `https://api-didaticos.educacaoadventista.org.br/open/${this.data.uuid}?frame=1&t=${token}${
      this.hasBookExterno || this.isExternal ? '&ex=true' : ''
    }${isStudent ? '&aluno=true' : ''}`;
  }
}
